import { head, identity, pickBy } from 'lodash/fp';

export const getSolutionMarketplaceTags = ({ item }: any) =>
  pickBy(identity, {
    tax_integration_category: (item?.integration_type?.raw || [])[0],
    tax_product_category: (item?.product_type?.raw || [])[0],
  });

export const getSolutionMarketplaceLabels = ({ item }: any) => {
  return {
    tax_content_category: head(item?.tax_content_category?.raw),
  };
};

export enum SearchInProviders {
  IN_SOLUTIONS = '-solutions',
  IN_BOTH = '-tech-partners',
  IN_PARTNERS = '-profiles',
}
